import Vue from 'vue'
import App from './App.vue'
import './plugins/iview.js'
import router from './router'
import coreData from "./coreData";

// console.log(`http://${process.env.VUE_APP_HOST}:8085`);
// console.log(process.env);

Vue.config.productionTip = false;

//全局变量
Vue.prototype.$coreData = coreData;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');

//设置css样式
import "./common.css";

